/* components/LoadMore */

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class TabbedSlider extends ThemeComponent {
    @Ref() tabs!: HTMLDivElement[];
    @Ref() buttons !: HTMLButtonElement[];

    init() {
        if (!this.tabs) { return; }

        for (const button of this.buttons) {
            this.$listen(button, 'click', (e) => {
                this.toggleTab(e);
            });
        }
    }

    toggleTab(e: MouseEvent) {
        const button = e.target as HTMLButtonElement;
        const selectedTabIndex = Number(button.dataset.index) - 1;

        for (const tab of this.tabs) {
            if (tab.classList.contains('is-active')) {
                tab.classList.remove('is-active');
            }
        }

        for (const button of this.buttons) {
            if (button.classList.contains('button--primary')) {
                button.classList.remove('button--primary');
            }
        }

        this.tabs[selectedTabIndex]?.classList.add('is-active');
        button.classList.add('button--primary');
    }
}
